import React, { useEffect, useState } from 'react'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency'
import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import { useSnackbar } from '../../alert/SnackbarProvider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import '../../styles/main.css'
import { updateData, addRequestsData } from '../../api/indexedDBHandler'
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'

import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import AddTaskIcon from '@mui/icons-material/AddTask'
import Dialog from '@mui/material/Dialog'
import Divider from '@mui/material/Divider'
import MenuList from '@mui/material/MenuList'
import IconButton from '@mui/material/IconButton'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import Modal from '@mui/material/Modal'
import { BorderAllRounded } from '@mui/icons-material'
import CircularProgress from '@mui/material/CircularProgress'
import StarIcon from '@mui/icons-material/Star'
import ModalAddTeam from '../Modal/ModalAddTeam'
const TeamSettingsCard = ({ teamData, athleteData }) => {
  const { id } = useParams()
  const [openBackdrop, setOpenBackdrop] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [openModal, setOpenModal] = React.useState(false)
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)
  const [sumPaid, setSumPaid] = React.useState('')
  const [paid, setPaid] = React.useState(0)
  const [openModalSportsmen, setOpenModalopenModalSportsmen] =
    React.useState(false)
  const handleCloseModalSportsmen = () => setOpenModalopenModalSportsmen(false)
  const [error, setError] = useState('')
  const [error1, setError1] = useState('')
  const [loading, setLoading] = useState(false)

  const [modalAvatar, setModalAvatar] = React.useState('')
  const [modalName, setModalName] = React.useState('')
  const [modalIdentification, setModalIdentification] = React.useState('')
  const [modalId, setModalId] = React.useState('')
  const [modalDob, setModalDob] = React.useState('')
  const [modalPhone, setModalPhone] = React.useState('')
  const [modalSports_category, setModalSports_category] = React.useState('')
  const [modalInsurance, setModalInsurance] = React.useState('')
  const [modalMedical, setModalMedical] = React.useState('')
  const [modalRusad, setModalRusad] = React.useState('')

  const [teamName, setTeamName] = useState('')
  const [spName1, setSpName1] = useState('')
  const [spName2, setSpName2] = useState('')
  const [spName3, setSpName3] = useState('')
  const [openModalNewTeam, setModalNewTeam] = React.useState(false)
  const [editData, setEditData] = useState(null)

  useEffect(() => {
    setPaid(teamData.sum_paid ? teamData.sum_paid : 0)
  }, [teamData])
  const showSnackbar = useSnackbar()

  useEffect(() => {
    if (athleteData && teamData)
      setEditData({
        teamName: names(),
        spName1: athleteData[0]?.fio ? athleteData[0].fio.trim() : '',
        spid1: athleteData[0]?.id ? athleteData[0].id : null,
        category1: athleteData[0]?.sports_category
          ? athleteData[0].sports_category.trim()
          : '',
        date1:
          athleteData[0]?.dob && athleteData[0]?.dob != '0000-00-00'
            ? athleteData[0].dob.trim()
            : '',
        spName2: athleteData[1]?.fio ? athleteData[1].fio.trim() : '',
        spid2: athleteData[1]?.id ? athleteData[1].id : null,
        category2: athleteData[1]?.sports_category
          ? athleteData[1].sports_category.trim()
          : '',
        date2:
          athleteData[1]?.dob && athleteData[1]?.dob != '0000-00-00'
            ? athleteData[1].dob.trim()
            : '',
        spName3: athleteData[2]?.fio ? athleteData[2].fio.trim() : '',
        spid3: athleteData[2]?.id ? athleteData[2].id : null,
        category3: athleteData[2]?.sports_category
          ? athleteData[2].sports_category.trim()
          : '',
        date3:
          athleteData[3]?.dob && athleteData[3]?.dob != '0000-00-00'
            ? athleteData[3].dob.trim()
            : '',
      })
  }, [athleteData, teamData])

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',

    bgcolor: 'background.paper',

    boxShadow: 24,
    p: 4,
  }
  const handleKeyDown = (e) => {
    if (
      !/[0-9-]/.test(e.key) &&
      e.key !== 'Backspace' &&
      e.key !== 'Delete' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      e.key !== 'Tab' &&
      e.key !== 'Enter' &&
      !(e.ctrlKey || e.metaKey)
    ) {
      e.preventDefault()
    }
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  const names = () => {
    return teamData.preferred_name == 'en'
      ? teamData.team_name_en
        ? teamData.team_name_en
        : teamData.team_name_ru
      : teamData.team_name_ru
  }

  const name =
    teamData.preferred_name == 'en'
      ? teamData.team_name_en
        ? teamData.team_name_en
        : teamData.team_name_ru
      : teamData.team_name_ru
  const openCupBut = () => {
    // if (isAccess) navigate('/tournaments/' + id + '/' + path) && teams
  }
  const handleCloseModalNewTeam = () => {
    setModalNewTeam(false)
  }
  const validate = () => {
    setError('')
    setError1('')
    if (teamName.trim() === '') {
      setError('Название команды обязательно')
      return false
    }
    if (spName1.trim() === '') {
      setError1('ФИО одного спорсмена обязательно')
      return false
    }
    setError('')
    setError1('')
    return true
  }
  const handleSubmitTeamEdit = async (teamDataNew) => {
    setOpenBackdrop(true)
    const update_data = {
      do: 'updNewTeam',
      teamName: teamDataNew.teamName.trim(),
      teamid: teamData.id,
      id: id,
      spName1: teamDataNew.spName1.trim(),
      spName2: teamDataNew.spName2.trim(),
      spName3: teamDataNew.spName3.trim(),
      category1: teamDataNew.category1,
      category2: teamDataNew.category2,
      category3: teamDataNew.category3,
      date1: teamDataNew.date1,
      date2: teamDataNew.date2,
      date3: teamDataNew.date3,
      spid1: athleteData[0]?.id
        ? athleteData[0].id
        : teamDataNew.spName1.trim() === ''
          ? null
          : Date.now(),
      spid2: athleteData[1]?.id
        ? athleteData[1].id
        : teamDataNew.spName2.trim() === ''
          ? null
          : Date.now(),
      spid3: athleteData[2]?.id
        ? athleteData[2].id
        : teamDataNew.spName3.trim() === ''
          ? null
          : Date.now(),
      requestKey: `${id}_updNewTeam_${new Date().getTime()}`,
    }
    // const requestKey = `${id}_dellUser_${new Date().getTime()}`
    // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
    try {
      await addRequestsData('requests', {
        url: 'teams/updNewTeam.php',
        ...update_data,
      })
      await new Promise((resolve) => setTimeout(resolve, 3000))
    } catch (error) {
      setOpenBackdrop(false)
    } finally {
      window.location.reload()
    }
  }
  const buttonEditType = async () => {
    if (validate()) {
      setLoading(true)
      const spid1 = athleteData[0]?.id ? athleteData[0].id : null
      const spid2 = athleteData[1]?.id ? athleteData[1].id : null
      const spid3 = athleteData[2]?.id ? athleteData[2].id : null

      const spName1s = spName1 ? spName1.trim() : ''
      const spName2s = spName2 ? spName2.trim() : ''
      const spName3s = spName3 ? spName3.trim() : ''

      const update_data = {
        do: 'updNewTeam',
        teamName: teamName.trim(),
        teamid: teamData.id,
        id: id,
        spName1: spName1s,
        spid1: spid1,
        spName2: spName2s,
        spid2: spid2,
        spName3: spName3s,
        spid3: spid3,
        requestKey: `${id}_updNewTeam_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'teams/updNewTeam.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 3000))
      } catch (error) {
      } finally {
        window.location.reload()
      }
    }
  }
  const handleClickOpen = () => {
    setOpen(true)
  }

  const addPaidTeam = () => {
    setSumPaid('')
    setOpen(false)
    setOpenModal(true)
  }
  const dellTeamList = async () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Удалить команду из списка?  ' + name + '?')
    if (result) {
      setOpenModal(false)
      setOpen(false)
      setOpenBackdrop(true)
      const update_data = {
        do: 'dellTeamList',
        team: teamData.id,
        id: id,
        requestKey: `${id}_dellTeamList_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'teams/dellTeamList.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 3000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        showSnackbar('Данные сохранены', 'success')
        window.location.reload()
      }
    }
  }

  const addTeamList = async () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Подтвердить заявку от команды ' + name + '?')
    if (result) {
      setOpenModal(false)
      setOpen(false)
      setOpenBackdrop(true)
      const update_data = {
        do: 'addTeamList',
        team: teamData.id,
        id: id,
        requestKey: `${id}_addTeamList_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'teams/addTeamList.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 3000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        showSnackbar('Данные сохранены', 'success')
        window.location.reload()
      }
    }
  }

  const addPaidSave = async () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Добавить взнос ' + sumPaid + ' руб.?')
    if (result) {
      const newPaid = Number(paid) + Number(sumPaid)
      setPaid(newPaid)
      setOpenModal(false)
      const update_data = {
        do: 'newPaid',
        newPaid: newPaid,
        team: teamData.id,
        id: id,
        requestKey: `${id}_paid_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'paid/paid.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        showSnackbar('Данные сохранены', 'success')
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpanSp = (e) => {
    setModalName(e.fio)

    setModalIdentification('аккаунт: ' + e.identification)
    const idsp = e.id == 72 ? '072' : e.id == 7 ? '007' : e.id
    setModalId('ID в системе ПротоКарп: ' + idsp)
    setModalPhone('Телефон: ' + e.phone)
    setModalDob(
      e.dob !== '0000-00-00'
        ? 'Дата рождения: ' + formatDateToDDMMYYYY(e.dob)
        : 'Дата рождения: нет данных'
    )
    const insurance = e.insurance
      ? 'Спортивная страховка: ' + e.insurance
      : 'Спортивная страховка: нет данных'
    const insurance_expiry = e.insurance_expiry
      ? ', до ' + formatDateToDDMMYYYY(e.insurance_expiry)
      : ''
    setModalInsurance(insurance + insurance_expiry)

    const medical_clearance_expiry = e.medical_clearance_expiry
      ? 'Допуск врача: до ' + formatDateToDDMMYYYY(e.medical_clearance_expiry)
      : 'Допуск врача: нет данных'

    setModalMedical(medical_clearance_expiry)

    const rusad_certificate = e.rusad_certificate
      ? 'Сертификат РУСАД: ' + e.rusad_certificate
      : 'Сертификат РУСАД: нет данных'

    const rusad_expiry = e.rusad_expiry
      ? ', от ' + formatDateToDDMMYYYY(e.rusad_expiry)
      : ''
    setModalRusad(rusad_certificate + rusad_expiry)
    const sports_category = e.sports_category ? e.sports_category : ''
    const sports_category_order_date = e.sports_category_order_date
      ? e.sports_category_order_date != '0000-00-00'
        ? ' от ' + formatDateToDDMMYYYY(e.sports_category_order_date)
        : ''
      : ''
    const sports_category_order_number = e.sports_category_order_number
      ? ' №' + e.sports_category_order_number
      : ''
    const sp_cat =
      sports_category +
      sports_category_order_number +
      sports_category_order_date

    setModalSports_category(
      sp_cat ? 'Спортивный разряд: ' + sp_cat : 'Спортивный разряд: нет данных'
    )
    setModalAvatar(e.avatar)
    setOpenModalopenModalSportsmen(true)
  }
  const dob_sport_categori = (sports_category, dob) => {
    var arr = []
    if (sports_category) arr.push(sports_category)
    if (dob != '0000-00-00') arr.push(formatDateToDDMMYYYY(dob) + ' г.р.')
    return arr.join(', ')
  }
  function formatNumberWithDots(number) {
    if (!number) return 0
    return number.toLocaleString('ru-RU').replace(/\s/g, '.')
  }
  const cup_paid = () => {
    if (teamData.type_paid == 1) return teamData.sum_paid_1
    if (teamData.type_paid == 2) {
      if (athleteData[2]) return teamData.sum_paid_2
      else return teamData.sum_paid_1
    }
  }

  const editTeam = () => {
    setOpen(false)
    setTeamName(name)
    setSpName1('')
    setSpName1(athleteData[0]?.fio)
    setSpName2('')
    setSpName2(athleteData[1]?.fio)
    setSpName3('')
    setSpName3(athleteData[2]?.fio)
    setModalNewTeam(true)
  }

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid size={{ xs: 12, md: 12 }} onClick={openCupBut}>
        <Item className="regateam" style={{ padding: '18px' }}>
          <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
            {teamData.logo && (
              <img
                alt="Logo Team"
                variant="square"
                src={'https://protocarp.ru/' + teamData.logo}
                style={{ objectFit: 'contain !important', height: '40px' }}
              />
            )}

            <div>
              <Typography
                variant="h6"
                gutterBottom
                style={{ marginBottom: '0px', lineHeight: '1.2' }}
                className="color-text-black"
              >
                {name}
              </Typography>
              <Typography variant="caption" gutterBottom>
                {teamData.name}
              </Typography>
            </div>
            <Box sx={{ flexGrow: 1 }} />
            <div>
              <IconButton onClick={handleClickOpen}>
                <MoreVertIcon />
              </IconButton>
              <Dialog
                open={open}
                onClose={handleClose}
                slotProps={{
                  paper: {
                    component: 'form',
                    onSubmit: (event) => {
                      event.preventDefault()
                      const formData = new FormData(event.currentTarget)
                      const formJson = Object.fromEntries(formData.entries())
                      const email = formJson.email

                      handleClose()
                    },
                  },
                }}
              >
                <DialogContent>
                  <Paper style={{ boxShadow: 'none' }}>
                    <MenuList dense>
                      <MenuItem
                        disabled={teamData.edit}
                        onClick={(e) => editTeam()}
                      >
                        <ListItemIcon>
                          <ModeEditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText secondary={teamData.secondary}>
                          Редактировать данные команды
                        </ListItemText>
                      </MenuItem>
                      <MenuItem onClick={addPaidTeam}>
                        <ListItemIcon>
                          <CreditCardIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Добавить взнос команды</ListItemText>
                      </MenuItem>

                      <Divider />
                      {teamData.status == 'Заявка одобрена' ? (
                        <MenuItem
                          style={{ color: 'red' }}
                          onClick={dellTeamList}
                        >
                          <ListItemIcon>
                            <DeleteForeverIcon
                              fontSize="small"
                              style={{ fill: 'red' }}
                            />
                          </ListItemIcon>
                          <ListItemText>Удалить команду</ListItemText>
                        </MenuItem>
                      ) : (
                        <MenuItem
                          style={{ color: 'green' }}
                          onClick={addTeamList}
                        >
                          <ListItemIcon>
                            <AddTaskIcon
                              fontSize="small"
                              style={{ fill: 'green' }}
                            />
                          </ListItemIcon>
                          <ListItemText>
                            Подтвердить заявку от команды
                          </ListItemText>
                        </MenuItem>
                      )}
                    </MenuList>
                  </Paper>
                </DialogContent>
              </Dialog>
            </div>
          </Stack>
          {athleteData.map((athlete, index) => (
            <Stack
              key={athlete.id}
              direction="row"
              spacing={2}
              style={{ textAlign: 'left', paddingTop: '20px' }}
            >
              <Avatar
                alt={athlete.fio}
                src={athlete.avatar}
                sx={{ width: 45, height: 45 }}
              />

              <div>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ marginBottom: '0px' }}
                  className="color-text-black"
                >
                  {athlete.fio}{' '}
                  {athlete.identification == 'идентифицирован' ? (
                    <StarIcon fontSize="small" style={{ fill: '#2a52be' }} />
                  ) : (
                    <></>
                  )}
                </Typography>
                <Typography
                  variant="caption"
                  gutterBottom
                  sx={{ display: 'block' }}
                >
                  {dob_sport_categori(athlete.sports_category, athlete.dob)}
                </Typography>
              </div>
              <Box sx={{ flexGrow: 1 }} />
              <div>
                <IconButton
                  color="primary"
                  aria-label=" "
                  onClick={() => handleOpanSp(athlete)}
                >
                  {athlete.isBot ? (
                    <SmartToyIcon style={{ fill: 'grey' }} />
                  ) : (
                    <ContactEmergencyIcon />
                  )}
                </IconButton>
              </div>
            </Stack>
          ))}

          <Stack
            direction="row"
            spacing={2}
            style={{ textAlign: 'center', paddingTop: '10px', width: '100%' }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className="color-text-black"
            >
              Взнос: {formatNumberWithDots(paid)} из{' '}
              {formatNumberWithDots(cup_paid())}
            </Typography>
          </Stack>
        </Item>
      </Grid>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="subtitle1">
            <b> Добавить взнос для команды {name}</b>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Текущий взнос команды: {formatNumberWithDots(paid)} из{' '}
            {formatNumberWithDots(cup_paid())}
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            style={{ textAlign: 'center', paddingTop: '10px', width: '100%' }}
          >
            <TextField
              id="outlined-basic"
              label=""
              variant="outlined"
              size="small"
              type="number"
              value={sumPaid}
              onChange={(e) => setSumPaid(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button color="success" size="small" onClick={addPaidSave}>
              Добавить
            </Button>
          </Stack>
          <Typography
            variant="caption"
            className="color-text-gray"
            gutterBottom
            sx={{ display: 'block' }}
          >
            Если вы делаете возврат команде, введите сумму со знаком минус.{' '}
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={openModalSportsmen}
        onClose={handleCloseModalSportsmen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            spacing={2}
            style={{ textAlign: 'left', paddingTop: '10px', width: '100%' }}
          >
            <Avatar
              id="avataridsp"
              alt="s"
              src={modalAvatar}
              sx={{ width: 72, height: 72 }}
            />
            <div>
              <Typography variant="subtitle1">{modalName}</Typography>
              <Typography variant="subtitle1">{modalIdentification}</Typography>
            </div>
          </Stack>
          <Typography
            variant="body2"
            id="modal-modal-description"
            sx={{ mt: 2 }}
          >
            {modalPhone}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalId}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalDob}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalSports_category}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalMedical}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalInsurance}
          </Typography>
          <Typography variant="body2" id="modal-modal-description">
            {modalRusad}
          </Typography>
        </Box>
      </Modal>
      {/* <Modal
        open={openModalNewTeam}
        onClose={handleCloseModalNewTeam}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6">Редактировать команду</Typography>
          <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
            В созданных вами командах спортсмены не смогут редактировать свои
            данные, загружать автарки и использовать их снова. Они могут
            самостоятельно подать заявку из своего личного кабинета
            www.protocarp.ru
          </Typography>
          <TextField
            id="outlined-basic"
            label="Название команды"
            variant="outlined"
            fullWidth
            error={!!error}
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            sx={{ mt: 2 }}
          />
          <TextField
            id="outlined-basic"
            label="ФИО спортсмена 1"
            variant="outlined"
            fullWidth
            error={!!error1}
            value={spName1}
            onChange={(e) => setSpName1(e.target.value)}
            sx={{ mt: 2 }}
          />
          <TextField
            id="outlined-basic"
            label="ФИО спортсмена 2"
            variant="outlined"
            fullWidth
            value={spName2}
            onChange={(e) => setSpName2(e.target.value)}
            sx={{ mt: 1 }}
          />
          <TextField
            id="outlined-basic"
            label="ФИО спортсмена 3"
            variant="outlined"
            fullWidth
            value={spName3}
            onChange={(e) => setSpName3(e.target.value)}
            sx={{ mt: 1 }}
          />
          <Typography variant="body2" gutterBottom>
            Созданные команды сразу попадают в основной список с подтвержденной
            регистрацией.
          </Typography>
          <Box mt={1} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="success"
              onClick={buttonEditType}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} />}
            >
              {loading ? 'Загрузка...' : 'Сохранить'}
            </Button>
          </Box>
        </Box>
      </Modal> */}
      <ModalAddTeam
        open={openModalNewTeam}
        onClose={() => setModalNewTeam(false)}
        onSubmit={handleSubmitTeamEdit}
        data={editData}
      />
    </>
  )
}

export default TeamSettingsCard
